import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/mobileMenu.js";

function MobileMenu() {
  useEffect(() => {
    // Mobile Menu
    const hmBtn = document.getElementById("mb-sidebar-btn");

    if (hmBtn) {
      const mdSidebarOverlay = document.getElementById("mb-sidebar-overlay");
      const mdSidebarBody = document.getElementById("mb-sidebar-body");
      const mdSidebarExit = document.getElementById("close-mb-sidebar");

      hmBtn.addEventListener("click", function (e) {
        e.preventDefault();
        mdSidebarOverlay.classList.toggle("visible");
        mdSidebarBody.classList.toggle("opened");
      });

      mdSidebarOverlay.addEventListener("click", function (e) {
        e.preventDefault();
        mdSidebarOverlay.classList.remove("visible");
        mdSidebarBody.classList.remove("opened");
      });

      mdSidebarExit.addEventListener("click", function (e) {
        e.preventDefault();
        mdSidebarOverlay.classList.remove("visible");
        mdSidebarBody.classList.remove("opened");
      });
    }

    // Menu Accordion - Main categories
    const menuButton = document.querySelectorAll(".mb-menu-button");
    menuButton.forEach((button) => {
      button.addEventListener("click", () => {
        button.classList.toggle("active");
        const content = button.nextElementSibling;

        if (button.classList.contains("active")) {
          content.className = "mb-menu-content show";
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          content.className = "mb-menu-content";
          content.style.maxHeight = "0";
        }
      });
    });

    // Sub Menu Accordion - Nested categories
    const subMenuButton = document.querySelectorAll(".mb-submenu-button");
    subMenuButton.forEach((button) => {
      button.addEventListener("click", () => {
        button.classList.toggle("active");
        const content = button.nextElementSibling;
        const parentContent = button.closest(".mb-menu-content");

        if (button.classList.contains("active")) {
          content.className = "mb-submenu-content show";
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          content.className = "mb-submenu-content";
          content.style.maxHeight = "0";
        }

        // Adjust parent height to accommodate submenu
        if (parentContent) {
          parentContent.style.maxHeight = parentContent.scrollHeight + "px";
        }
      });
    });
  });

  return (
    <Styles>
      {/* Mobile Menu */}
      <section className="mobile-menu-area">
        <Container>
          <Row>
            <Col md="0" sm="12">
              <div className="mb-topbar d-flex justify-content-between">
                <div className="topbar-item">
                  <p>
                    <i className="las la-phone"></i>+91 9022547856
                  </p>
                </div>
                <div className="topbar-item">
                  <ul className="list-unstyled list-inline">
                    <li className="list-inline-item">
                      <Link to={process.env.PUBLIC_URL + "/login"}>Log In</Link>
                    </li>
                    <li className="list-inline-item">/</li>
                    <li className="list-inline-item">
                      <Link to={process.env.PUBLIC_URL + "/registration"}>
                        Register
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mb-logo-area d-flex justify-content-between">
                <div className="mb-logo-box d-flex">
                  <div className="hm-button">
                    <a href={process.env.PUBLIC_URL + "/"} id="mb-sidebar-btn">
                      <i className="las la-bars"></i>
                    </a>
                  </div>
                  <div className="mb-logo">
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/f-logo.png"
                        }
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
                <div className="mb-search-box">
                  <form action="#">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search Here"
                    />
                    <button type="submit">
                      <i className="las la-search"></i>
                    </button>
                  </form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mobile Menu Sidebar */}
      <section className="mb-sidebar" id="mb-sidebar-body">
        <div className="mb-sidebar-heading d-flex justify-content-between">
          <div>
            <h5>Menu</h5>
          </div>
          <div>
            <a href={process.env.PUBLIC_URL + "/"} id="close-mb-sidebar">
              <i className="las la-times"></i>
            </a>
          </div>
        </div>
        <div className="mb-sidebar-menu">
          {/* Home */}
          <div className="mb-menu-item">
            <button className="mb-menu-button active">
              <p>
                Home <i className="las la-plus"></i>
              </p>
            </button>
            <div className="mb-menu-content show">
              <ul className="list-unstyled">
                <li>
                  <Link to={process.env.PUBLIC_URL + "/"}>Home Style 1</Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/home-two"}>
                    Home Style 2
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Chancellor */}
          <div className="mb-menu-item">
            <button className="mb-menu-button active">
              <p>
                Chancellor <i className="las la-plus"></i>
              </p>
            </button>
            <div className="mb-menu-content show">
              <ul className="list-unstyled">
                <li>
                  <Link to={process.env.PUBLIC_URL + "/chancellor"}>
                    About Chancellor of Public Universities of Maharashtra
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Pages with Nested Menu */}
          <div className="mb-menu-item">
            <button className="mb-menu-button active">
              <p>
                Pages <i className="las la-plus"></i>
              </p>
            </button>
            <div className="mb-menu-content show">
              {/* Law Education Submenu */}
              <div className="mb-submenu-item">
                <button className="mb-submenu-button">
                  <p>
                    Law Education <i className="las la-plus"></i>
                  </p>
                </button>
                <div className="mb-submenu-content">
                  <ul className="list-unstyled">
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/education/cet"}>
                        CET
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/education/nri"}>
                        NRI
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Law Colleges Submenu */}
              <div className="mb-submenu-item">
                <button className="mb-submenu-button">
                  <p>
                    Law Colleges <i className="las la-plus"></i>
                  </p>
                </button>
                <div className="mb-submenu-content">
                  <ul className="list-unstyled">
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/college/mumbai"}>
                        Mumbai Law Colleges
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/college/pune"}>
                        Pune Law Colleges
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/college/nagpur"}>
                        Nagpur Law Colleges
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/college/nashik"}>
                        Nashik Law Colleges
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/college/aurangabad"}>
                        Aurangabad Law Colleges
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Direct Page Links */}
              <ul className="list-unstyled mb-direct-links">
                <li>
                  <Link to={process.env.PUBLIC_URL + "/about"}>About Us</Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/contact"}>Contact</Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Courses with Nested Menu */}
          <div className="mb-menu-item">
            <button className="mb-menu-button active">
              <p>
                Courses <i className="las la-plus"></i>
              </p>
            </button>
            <div className="mb-menu-content show">
              {/* Undergraduate Courses Submenu */}
              <div className="mb-submenu-item">
                <button className="mb-submenu-button">
                  <p>
                    LAW PROGRAMS <i className="las la-plus"></i>
                  </p>
                </button>
                <div className="mb-submenu-content">
                  <ul className="list-unstyled">
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/courses/ba-llb"}>
                        BA LLB (5 Years)
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/courses/bba-llb"}>
                        BBA LLB (5 Years)
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/courses/bcom-llb"}>
                        B.Com LLB (5 Years)
                      </Link>
                    </li>
                    <li>
                      <Link to={process.env.PUBLIC_URL + "/courses/llb"}>
                        LLB (3 Years)
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-menu-item">
            <button className="mb-menu-button">
              <p>
                COURSE MATERIALS <i className="las la-plus"></i>
              </p>
            </button>
            <div className="mb-menu-content">
              <ul className="list-unstyled">
                <li>
                  <Link to={process.env.PUBLIC_URL + "/courses/lecture"}>
                    NOTES BY RENOWNED LECTURERS
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/courses/reading"}>
                    READING MATERIALS
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Event */}
          <div className="mb-menu-item">
            <button className="mb-menu-button">
              <p>
                Event <i className="las la-plus"></i>
              </p>
            </button>
            <div className="mb-menu-content">
              <ul className="list-unstyled">
                <li>
                  <Link to={process.env.PUBLIC_URL + "/events"}>Events</Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/event-details"}>
                    Event Details
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Blog */}
          <div className="mb-menu-item">
            <button className="mb-menu-button">
              <p>
                Blog <i className="las la-plus"></i>
              </p>
            </button>
            <div className="mb-menu-content">
              <ul className="list-unstyled">
                <li>
                  <Link to={process.env.PUBLIC_URL + "/blog-classic"}>
                    Blog Classic
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/blog-grid"}>
                    Blog Grid
                  </Link>
                </li>
                <li>
                  <Link to={process.env.PUBLIC_URL + "/blog-details"}>
                    Blog Details
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Videos */}
          <div className="mb-menu-item">
            <button className="mb-menu-button">
              <p>
                Videos <i className="las la-plus"></i>
              </p>
            </button>
            <div className="mb-menu-content">
              <ul className="list-unstyled">
                <li>
                  <Link to={process.env.PUBLIC_URL + "/video"}>Videos</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <div className="mb-sidebar-overlay" id="mb-sidebar-overlay"></div>
    </Styles>
  );
}

export default MobileMenu;
